module.exports = __webpack_public_path__ + "static/haven-logo-141581a77864741dc173ac5a2ac5b8cd.jpeg";